import useApiClient from "./client";
import { API_URL } from "../constants";
import { useSetRecoilState } from "recoil";
import { authAtom, DEFAULT_AUTH_ATOM_VALUE } from "../state";

const useAuthApiClient = () => {
  const apiClient = useApiClient();
  let setAuth = useSetRecoilState(authAtom);

  const exchangeAuthorizationCode = async (authCode) => {
    return await apiClient.post(`${API_URL}/auth/code`, {
      authorizationCode: authCode,
    });
  };

  const revokeToken = async (accessToken) => {
    await apiClient.post(`${API_URL}/auth/revoke`, { accessToken });
    setAuth(DEFAULT_AUTH_ATOM_VALUE);
  };

  return { exchangeAuthorizationCode, revokeToken };
};

export { useAuthApiClient };
